import gql from "graphql-tag";

export const STEMMER_SEARCH_PEOPLE = gql`
  query stemmerSearchPeople($fullName: String) {
    StemmerSearchPeople(fullName: $fullName) {
      id
      fullName
      imageDepictions {
        file {
          uri
        }
      }
    }
  }
`;

export const STEMMER_SEARCH_PEOPLE_NOT_IN_PROJECT = gql`
  query stemmerSearchPeopleNotInProject(
    $searchPhrase: String
    $projectId: String
  ) {
    StemmerSearchPeopleNotMembersNotOwnersOfProject(
      searchPhrase: $searchPhrase
      projectId: $projectId
    ) {
      id
      accountId
      fullName
      emailAddress
      alias
      description
      biography
      imageDepictions {
        thumbnail {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const SEARCH_PEOPLE_BY_EMAIL = gql`
  query findPersonByEmail($email: String) {
    StemmerSearchPeopleByEmail(email: $email) {
      id
      accountId
      fullName
      alias
      description
      emailAddress
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const GET_PERSON = gql`
  query Person(
    $id: ID
    $dpid: String
    $isni: String
    $ipi: String
    $ipn: String
    $musicbrainzGuid: String
    $cisacSocietyID: String
    $fullName: String
    $keyName: String
    $abbreviatedName: String
    $description: String
    $postalAddressLine: String
    $postalCityName: String
    $postalDistrictName: String
    $postCode: String
    $postalTerritoryCode: String
    $phoneNumber: String
    $emailAddress: String
    $website: String
    $territoryOfResidency: String
    $nationality: String
    $dateOfBirth: _Neo4jDateInput
    $dateOfDeath: _Neo4jDateInput
    $placeOfBirth: String
    $placeOfDeath: String
    $accountId: String
    $biography: String
    $gender: String
    $creativePassportId: String
    $acceptedDelicTandCs: Boolean
    $seenProjectHelp: Boolean
    $authStatus: AuthStatus
  ) {
    Person(
      id: $id
      dpid: $dpid
      isni: $isni
      ipi: $ipi
      ipn: $ipn
      musicbrainzGuid: $musicbrainzGuid
      cisacSocietyID: $cisacSocietyID
      fullName: $fullName
      keyName: $keyName
      abbreviatedName: $abbreviatedName
      description: $description
      postalAddressLine: $postalAddressLine
      postalCityName: $postalCityName
      postalDistrictName: $postalDistrictName
      postCode: $postCode
      postalTerritoryCode: $postalTerritoryCode
      phoneNumber: $phoneNumber
      emailAddress: $emailAddress
      website: $website
      territoryOfResidency: $territoryOfResidency
      nationality: $nationality
      dateOfBirth: $dateOfBirth
      dateOfDeath: $dateOfDeath
      placeOfBirth: $placeOfBirth
      placeOfDeath: $placeOfDeath
      accountId: $accountId
      biography: $biography
      gender: $gender
      creativePassportId: $creativePassportId
      acceptedDelicTandCs: $acceptedDelicTandCs
      seenProjectHelp: $seenProjectHelp
      authStatus: $authStatus
    ) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      authStatus
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      invitationsCreated {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      assets {
        __typename
        ... on Project {
          id
          title
        }
        ... on Share {
          id
          percent
          territoryCode
          work {
            id
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id
            title
            type
            isMainRelease
            releaseDetails {
              id
              artwork {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id
        role
        featured
        contracted
        isCredited
        contributedTo {
          __typename
          ... on Component {
            id
            title
          }
          ... on Work {
            id
            title
          }
        }
      }
    }
  }
`;

export const GET_PERSON_BY_ACCOUNT_ID = gql`
  query PersonByAccountId($accountId: String!) {
    PersonByAccountId(accountId: $accountId) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      authStatus
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      invitationsCreated {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      assets {
        __typename
        ... on Project {
          id
          title
        }
        ... on Share {
          id
          percent
          territoryCode
          work {
            id
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id
            title
            type
            isMainRelease
            releaseDetails {
              id
              artwork {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id
        role
        featured
        contracted
        isCredited
        contributedTo {
          __typename
          ... on Component {
            id
            title
          }
          ... on Work {
            id
            title
          }
        }
      }
      publicProfiles {
        id
        title
        description
        donateLink
        public
        owners {
          id
          accountId
          fullName
          description
          imageDepictions {
            id
            title
            type
            file {
              id
              filename
              uri
              size
            }
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
        videos {
          id
          url
          isProjectRevoked
          creationDate {
            formatted
          }
          isLiveStreamOf {
            id
          }
        }
      }
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
        thumbnailOf {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const GET_PERSON_BY_EMAIL = gql`
  query PersonByEmail($email: String!) {
    PersonByEmail(email: $email) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      authStatus
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      invitationsCreated {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      publicProfiles {
        id
        title
        description
        donateLink
        public
        owners {
          id
          accountId
          fullName
          description
          imageDepictions {
            id
            title
            type
            file {
              id
              filename
              uri
              size
            }
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
        videos {
          id
          url
          isProjectRevoked
          creationDate {
            formatted
          }
          isLiveStreamOf {
            id
          }
        }
      }
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
        thumbnailOf {
          id
          file {
            uri
          }
        }
      }
      projectsMembership {
        id
      }
    }
  }
`;

export const GET_PERSON_FROM_ACCOUNT_ID = gql`
  query getPersonFromAccountId($accountId: String!) {
    GetPersonFromAccountId(accountId: $accountId) {
      id
      fullName
    }
  }
`;

export const CREATE_PERSON = gql`
  mutation createPerson($person: PersonInput) {
    CreatePerson(person: $person) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      authStatus
    }
  }
`;

export const UPDATE_INVITED_PERSON = gql`
  mutation updateInvitedPerson(
    $personInput: PersonInput
    $projectId: ID!
    $currentPersonAuthStatus: String
    $currentInvitationStatus: String
    $invitationIsArchived: Boolean
    $invitationInput: InvitationInput
    $invitationId: ID!
    $inviteeId: ID!
  ) {
    UpdateInvitedPerson(
      personInput: $personInput
      projectId: $projectId
      currentPersonAuthStatus: $currentPersonAuthStatus
      currentInvitationStatus: $currentInvitationStatus
      invitationIsArchived: $invitationIsArchived
      invitationInput: $invitationInput
      invitationId: $invitationId
      inviteeId: $inviteeId
    ) {
      id
      accountId
      fullName
      emailAddress
      authStatus
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      authStatus
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      assets {
        __typename
        ... on Project {
          id
          title
        }
        ... on Share {
          id
          percent
          territoryCode
          work {
            id
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id
            title
            type
            isMainRelease
            releaseDetails {
              id
              artwork {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id
        role
        featured
        contracted
        isCredited
        contributedTo {
          __typename
          ... on Component {
            id
            title
          }
          ... on Work {
            id
            title
          }
        }
      }
      publicProfiles {
        id
        title
        description
        donateLink
        public
        owners {
          id
          accountId
          fullName
          description
          imageDepictions {
            id
            title
            type
            file {
              id
              filename
              uri
              size
            }
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
        videos {
          id
          url
          creationDate {
            formatted
          }
          isLiveStreamOf {
            id
          }
        }
      }
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
        thumbnailOf {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const UPDATE_PERSON = gql`
  mutation updatePerson($input: PersonInput) {
    UpdatePerson(input: $input) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      authStatus
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      invitationsCreated {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      assets {
        __typename
        ... on Project {
          id
          title
        }
        ... on Share {
          id
          percent
          territoryCode
          work {
            id
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id
            title
            type
            isMainRelease
            releaseDetails {
              id
              artwork {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id
        role
        featured
        contracted
        isCredited
        contributedTo {
          __typename
          ... on Component {
            id
            title
          }
          ... on Work {
            id
            title
          }
        }
      }
      publicProfiles {
        id
        title
        description
        donateLink
        public
        owners {
          id
          accountId
          fullName
          description
          imageDepictions {
            id
            title
            type
            file {
              id
              filename
              uri
              size
            }
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
        videos {
          id
          url
          creationDate {
            formatted
          }
          isLiveStreamOf {
            id
          }
        }
      }
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
        thumbnailOf {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const ACCEPT_TERMS_AND_CONDITIONS = gql`
  mutation acceptTermsAndConditions($cognitoId: String!, $input: PersonInput) {
    AcceptTermsAndConditions(cognitoId: $cognitoId, input: $input) {
      id
      acceptedDelicTandCs
    }
  }
`;

export const MIGRATE_PERSON_ACCOUNT_ID = gql`
  mutation MigratePersonAccountId(
    $personId: String!
    $oldAccountId: String!
    $newAccountId: String!
  ) {
    MigratePersonAccountId(
      personId: $personId
      oldAccountId: $oldAccountId
      newAccountId: $newAccountId
    ) {
      id
      dpid
      isni
      ipi
      ipn
      musicbrainzGuid
      cisacSocietyID
      fullName
      alias
      keyName
      abbreviatedName
      description
      postalAddressLine
      postalCityName
      postalDistrictName
      postCode
      postalTerritoryCode
      phoneNumber
      emailAddress
      website
      territoryOfResidency
      nationality
      dateOfBirth {
        formatted
      }
      dateOfDeath {
        formatted
      }
      placeOfBirth
      placeOfDeath
      accountId
      biography
      gender
      creativePassportId
      acceptedDelicTandCs
      seenProjectHelp
      authStatus
      creationDate {
        formatted
      }
      lastModifiedDate {
        formatted
      }
      invitationsReceived {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      invitationsCreated {
        id
        status
        isArchived
        reminderDate {
          formatted
        }
        lastModifiedDate {
          formatted
        }
        invitationTo {
          id
        }
      }
      assets {
        __typename
        ... on Project {
          id
          title
        }
        ... on Share {
          id
          percent
          territoryCode
          work {
            id
            title
          }
        }
        ... on ReleaseDetail {
          release {
            id
            title
            type
            isMainRelease
            releaseDetails {
              id
              artwork {
                id
                file {
                  uri
                }
              }
            }
          }
        }
      }
      contributions {
        id
        role
        featured
        contracted
        isCredited
        contributedTo {
          __typename
          ... on Component {
            id
            title
          }
          ... on Work {
            id
            title
          }
        }
      }
      publicProfiles {
        id
        title
        description
        donateLink
        public
        owners {
          id
          accountId
          fullName
          description
          imageDepictions {
            id
            title
            type
            file {
              id
              filename
              uri
              size
            }
            thumbnail {
              id
              file {
                uri
              }
            }
          }
        }
        videos {
          id
          url
          creationDate {
            formatted
          }
          isLiveStreamOf {
            id
          }
        }
      }
      imageDepictions {
        id
        title
        type
        file {
          id
          fileName
          uri
          size
        }
        thumbnail {
          id
          file {
            uri
          }
        }
        thumbnailOf {
          id
          file {
            uri
          }
        }
      }
    }
  }
`;

export const DELETE_PERSON = gql`
  mutation deletePerson($id: ID!) {
    DeletePerson(id: $id) {
      id
    }
  }
`;

export const GET_IMG_DEPICTIONS_OF_TYPE = gql`
  mutation getImageOfType($id: ID!, $imgType: String) {
    GetImageOfType(id: $id, imgType: $imgType) {
      id
      title
      type
      file {
        id
        fileName
        uri
        size
      }
      thumbnail {
        id
        file {
          uri
        }
      }
      thumbnailOf {
        id
        file {
          uri
        }
      }
    }
  }
`;

export const ADD_IMG_DEPICTION = gql`
  mutation AddImageDepictionToPerson(
    $ownerId: ID!
    $fullSizeImageInput: ImageInput
    $thumbnailImageInput: ImageInput
    $fullsizeFileInput: FileInput
    $thumbnailFileInput: FileInput
  ) {
    AddImageDepictionToPerson(
      personId: $ownerId
      fullSizeImageInput: $fullSizeImageInput
      thumbnailImageInput: $thumbnailImageInput
      fullsizeFileInput: $fullsizeFileInput
      thumbnailFileInput: $thumbnailFileInput
    ) {
      id
      title
      subtitle
      version
      creationDate {
        formatted
      }
      creationDateIsApproximate
      lastModifiedDate {
        formatted
      }
      type
      status
      url
      file {
        id
        proprietaryId
        fileName
        fileType
        uri
        size
        bitDepth
        bitRate
        samplingRate
        codecType
      }
      height
      width
      thumbnail {
        id
        file {
          id
          uri
        }
      }
      thumbnailOf {
        id
        file {
          id
          uri
        }
      }
      depicts {
        id
        fullName
      }
    }
  }
`;

export const REMOVE_IMG_DEPICTIONS = gql`
  mutation RemoveImageDepictionsFromPerson($personId: ID!, $imgType: String) {
    RemoveImageDepictionsFromPerson(personId: $personId, imgType: $imgType)
  }
`;
export const REPLACE_INVITEE_WITH_EXISTING_PERSON = gql`
  mutation replaceInviteeWithExistingPerson(
    $originalInviteeId: ID!
    $newInviteeId: ID!
    $projectId: ID!
    $creatorId: ID!
  ) {
    ReplaceInviteeWithExistingPerson(
      originalInviteeId: $originalInviteeId
      newInviteeId: $newInviteeId
      projectId: $projectId
      creatorId: $creatorId
    ) {
      id
      fullName
      lastModifiedDate {
        formatted
      }
      projectsMembership {
        id
      }
    }
  }
`;

export const GET_ROLES_FOR_COMPONENT = gql`
  query getRolesForComponent($personId: ID!, $componentId: ID!) {
    Person(id: $personId) {
      id
      contributionsFor(componentId: $componentId) {
        id
        role
      }
    }
  }
`;

export const GET_FOUNDER_MEMBER_STATUS = gql`
  query getFounderMemberStatus($hubspotId: String!) {
    GetFounderMemberStatus(hubspotId: $hubspotId)
  }
`;

// AddPersonTextDepictions(
//   from: _TextInput!
//   to: _PersonInput!
// ): _AddPersonTextDepictionsPayload
// RemovePersonTextDepictions(
//   from: _TextInput!
//   to: _PersonInput!
// ): _RemovePersonTextDepictionsPayload
// AddPersonImageDepictions(
//   from: _ImageInput!
//   to: _PersonInput!
// ): _AddPersonImageDepictionsPayload
// RemovePersonImageDepictions(
//   from: _ImageInput!
//   to: _PersonInput!
// ): _RemovePersonImageDepictionsPayload
// AddPersonVideoDepictions(
//   from: _VideoInput!
//   to: _PersonInput!
// ): _AddPersonVideoDepictionsPayload
// RemovePersonVideoDepictions(
//   from: _VideoInput!
//   to: _PersonInput!
// ): _RemovePersonVideoDepictionsPayload
// AddPersonProjects(
//   from: _PersonInput!
//   to: _ProjectInput!
// ): _AddPersonProjectsPayload
// RemovePersonProjects(
//   from: _PersonInput!
//   to: _ProjectInput!
// ): _RemovePersonProjectsPayload
// AddPersonContributions(
//   from: _PersonInput!
//   to: _ContributionInput!
// ): _AddPersonContributionsPayload
// RemovePersonContributions(
//   from: _PersonInput!
//   to: _ContributionInput!
// ): _RemovePersonContributionsPayload
// AddPersonWorksPublished(
//   from: _PersonInput!
//   to: _WorkInput!
// ): _AddPersonWorksPublishedPayload
// RemovePersonWorksPublished(
//   from: _PersonInput!
//   to: _WorkInput!
// ): _RemovePersonWorksPublishedPayload
// AddPersonReleases(
//   from: _PersonInput!
//   to: _ReleaseDetailInput!
// ): _AddPersonReleasesPayload
// RemovePersonReleases(
//   from: _PersonInput!
//   to: _ReleaseDetailInput!
// ): _RemovePersonReleasesPayload
// AddPersonReleasesOwned(
//   from: _PersonInput!
//   to: _ReleaseDetailInput!
// ): _AddPersonReleasesOwnedPayload
// RemovePersonReleasesOwned(
//   from: _PersonInput!
//   to: _ReleaseDetailInput!
// ): _RemovePersonReleasesOwnedPayload
// AddPersonRightsShares(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _AddPersonRightsSharesPayload
// RemovePersonRightsShares(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _RemovePersonRightsSharesPayload
// AddPersonRightsControlled(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _AddPersonRightsControlledPayload
// RemovePersonRightsControlled(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _RemovePersonRightsControlledPayload
// AddPersonRightsAdministered(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _AddPersonRightsAdministeredPayload
// RemovePersonRightsAdministered(
//   from: _PersonInput!
//   to: _ShareInput!
// ): _RemovePersonRightsAdministeredPayload
// AddPersonInstrumentsMade(
//   from: _InstrumentInput!
//   to: _PersonInput!
// ): _AddPersonInstrumentsMadePayload
// RemovePersonInstrumentsMade(
//   from: _InstrumentInput!
//   to: _PersonInput!
// ): _RemovePersonInstrumentsMadePayload
// AddPersonEquipmentMade(
//   from: _EquipmentInput!
//   to: _PersonInput!
// ): _AddPersonEquipmentMadePayload
// RemovePersonEquipmentMade(
//   from: _EquipmentInput!
//   to: _PersonInput!
// ): _RemovePersonEquipmentMadePayload
// AddPersonPaymentsMade(
//   from: _PersonInput!
//   to: _PaymentInput!
// ): _AddPersonPaymentsMadePayload
// RemovePersonPaymentsMade(
//   from: _PersonInput!
//   to: _PaymentInput!
// ): _RemovePersonPaymentsMadePayload
// AddPersonPaymentsReceived(
//   from: _PaymentInput!
//   to: _PersonInput!
// ): _AddPersonPaymentsReceivedPayload
// RemovePersonPaymentsReceived(
//   from: _PaymentInput!
//   to: _PersonInput!
// ): _RemovePersonPaymentsReceivedPayload
// AddPersonComments(
//   from: _PersonInput!
//   to: _CommentInput!
// ): _AddPersonCommentsPayload
// RemovePersonComments(
//   from: _PersonInput!
//   to: _CommentInput!
// ): _RemovePersonCommentsPayload
